// extracted by mini-css-extract-plugin
export default {"spinner_image":"d9b0ab","loading-spinner":"f9ab9b","spinner_wrapper":"c82f2f","show-spinner-animation":"c39598","spinner_wrapper__static":"da10e0"};